(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-mobile"] && !Shopify.designMode) return;
  try {
    class MediaGalleryMobile extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('.gallery-mob__carousel');
      this.slides = this.querySelectorAll('.gallery-mob__slide');
      this.dots = this.querySelectorAll('.gallery-mob__dot');
      this.thumbs = this.querySelectorAll('.gallery-mob__thumb');
      this.thumbsList = this.querySelector('.gallery-mob__thumbs-list');
      this.currentIndex = 0;
      this._programmaticTarget = null;
    }

    connectedCallback() {
      if (!this.carousel) return;

      this.carousel.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.carousel.addEventListener('pointerdown', () => {
        this._programmaticTarget = null;
      }, { passive: true });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.dotIndex, 10) - 1;
          this.goToSlide(idx);
        });
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.dataset.thumbIndex, 10) - 1;
          this.goToSlide(idx);
        });
      });

      this.updateDots();
      this.updateThumbs();
      this.updateSlides();
    }

    onScroll() {
      if (this._scrollTimeout) cancelAnimationFrame(this._scrollTimeout);
      this._scrollTimeout = requestAnimationFrame(() => {
        const scrollLeft = this.carousel.scrollLeft;
        const slideWidth = this.carousel.offsetWidth || 1;
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (this._programmaticTarget != null && newIndex !== this._programmaticTarget) {
          return;
        }
        if (this._programmaticTarget != null && newIndex === this._programmaticTarget) {
          this._programmaticTarget = null;
        }

        if (newIndex !== this.currentIndex) {
          this.currentIndex = newIndex;
          this.updateDots();
          this.updateThumbs();
          this.updateSlides();
        }
      });
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this._programmaticTarget = index;
      this.currentIndex = index;
      this.updateDots();
      this.updateThumbs();
      this.updateSlides();

      const slideWidth = this.carousel.offsetWidth;
      this.carousel.scrollTo({ left: slideWidth * index, behavior: 'smooth' });

      const clearProgrammatic = () => {
        this._programmaticTarget = null;
        this.carousel.removeEventListener('scrollend', clearProgrammatic);
      };
      this.carousel.addEventListener('scrollend', clearProgrammatic, { once: true });
      clearTimeout(this._scrollSettleTimer);
      this._scrollSettleTimer = setTimeout(clearProgrammatic, 500);
    }

    updateDots() {
      this.dots.forEach((dot, i) => {
        const isActive = i === this.currentIndex;
        dot.classList.toggle('active', isActive);
        dot.classList.toggle('is-active', isActive);
      });
    }

    updateSlides() {
      this.slides.forEach((slide, i) => {
        const isActive = i === this.currentIndex;
        slide.classList.toggle('active', isActive);
        slide.classList.toggle('is-active', isActive);
        if (isActive) return;

        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('.js-youtube').forEach((iframe) => {
          iframe.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        });
        slide.querySelectorAll('.js-vimeo').forEach((iframe) => {
          iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
        });
      });
    }

    updateThumbs() {
      if (!this.thumbs.length) return;

      this.thumbs.forEach((thumb, i) => {
        const item = thumb.closest('.gallery-mob__thumbs-item');
        const isActive = i === this.currentIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
        if (item) item.classList.toggle('is-active', isActive);
      });

      const activeThumb = this.thumbs[this.currentIndex];
      if (!activeThumb || !this.thumbsList) return;

      const listRect = this.thumbsList.getBoundingClientRect();
      const thumbRect = activeThumb.getBoundingClientRect();
      const edge = 2;

      if (thumbRect.left < listRect.left + edge) {
        this.thumbsList.scrollBy({ left: thumbRect.left - listRect.left - edge, behavior: 'smooth' });
      } else if (thumbRect.right > listRect.right - edge) {
        this.thumbsList.scrollBy({ left: thumbRect.right - listRect.right + edge, behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('media-gallery-mobile')) {
    customElements.define('media-gallery-mobile', MediaGalleryMobile);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["samples"] && !Shopify.designMode) return;
  try {
    class FreeSamples extends HTMLElement {
    constructor() {
      super();

      this.samplesAdded = parseFloat(this.getAttribute('data-samples-added')) || 0;
      this.samplesLimit = parseFloat(this.getAttribute('data-samples-limit')) || 0;
      this.addSamplesImmediately = this.getAttribute('data-add-samples') === 'true';
      this.addButton = this.querySelectorAll('.js-select-sample');
      this.productForm = this.closest('product-info')?.querySelector('.product-form form');
      this.samplesToAdd = [];

      this.addButton.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const sampleId = button.getAttribute('data-variant-id');
          if (this.addSamplesImmediately) {
            this.handleAddSample(sampleId);
          } else {
            if (button.classList.contains('selected')) {
              this.samplesToAdd = this.samplesToAdd.filter((id) => id !== sampleId);
              button.classList.remove('selected');
            } else if (this.samplesToAdd.includes(sampleId)) {
              this.samplesToAdd = this.samplesToAdd.filter((id) => id !== sampleId);
              button.classList.remove('selected');
            } else {
              this.samplesToAdd.push(sampleId);
              button.classList.add('selected');
            }

            this.checkLimit();
          }
        });
      });

      if (!this.addSamplesImmediately) {
        this.productForm.addEventListener('submit', (event) => {
          event.preventDefault();
          if (this.samplesToAdd.length > 0) {
            this.handleAddSample(this.samplesToAdd.join(','));
            this.samplesToAdd = [];
            this.addButton.forEach((button) => button.classList.remove('selected'));
          }
        });
      }
    }

connectedCallback() {
  if(this.dataset.sampleKeys) {
    this.handleRemoveGift();
  }
}


checkLimit() {
  if (this.samplesToAdd.length + this.samplesAdded >= this.samplesLimit) {
    this.addButton.forEach((button) => {
      if (!button.classList.contains('selected')) {
        button.setAttribute('disabled', 'true');
      }
    });
  } else {
    this.addButton.forEach((button) => {
      if (!button.classList.contains('selected')) {
        button.removeAttribute('disabled');
      }
    });
  }
}

handleAddSample(ids) {

  // Normalize and validate ids
  const idArray = String(ids)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const variantIds = idArray
    .map(s => Number.parseInt(s, 10))
    .filter(n => Number.isFinite(n));

  if (variantIds.length === 0) {
    console.error('[handleAddSample] No valid variant IDs parsed from:', ids);
    return;
  }

  if (variantIds.length !== idArray.length) {
    console.warn('[handleAddSample] Some IDs were invalid and were dropped.', { idArray, variantIds });
  }

  const formData = {
    items: variantIds.map((id) => ({
      id,
      quantity: 1,
      properties: { _sample: 'true' },
    })),
  };


  const parseResponse = async (res) => {
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      try { return await res.json(); } catch (_e) { /* fallthrough */ }
    }
    try { return await res.text(); } catch (_e) { return null; }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // credentials same-origin in case you rely on cookies; not strictly necessary in most themes
    credentials: 'same-origin',
    body: JSON.stringify(formData),
  })
    .then(async (res) => {
      const payload = await parseResponse(res);

      if (!res.ok) {
        // Shopify commonly returns 422 with a JSON body: { status: 422, message, description }
        const err = {
          status: res.status,
          statusText: res.statusText,
          payload,
        };
        console.error('[handleAddSample] /cart/add.js failed:', err);
        throw err;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'samples', payload });
      return payload;
    })
    .catch((error) => {
      console.error('[handleAddSample] Error adding items:', error);
    });
}


    handleRemoveGift() {
      const updates = this.dataset.sampleKeys
        .split(',')
        .map(key => key.trim())
        .filter(Boolean)
        .reduce((acc, key) => {
          acc[key] = 0;
          return acc;
        }, {});

      if(!updates) {
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase' });
        })
        .catch((error) => console.error('Error removing gift:', error));
    }
  }

  customElements.define('free-samples', FreeSamples);
  } catch(e) { console.error(e); }
})();

})();
